import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import {
  referralReportsPageLoad,
  loadJobFunctions,
  loadReferralsByJobFunction,
  loadReferralsByJobDepartment,
  loadOldestReferralDate,
  loadReferralCountByStage,
} from '@modules/reports/store/referral-reports.actions';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Subpages } from '@modules/reports/models/subpages';

@Injectable()
export class ReportsResolver {
  constructor(private store: Store<{}>) {}

  resolve(route: ActivatedRouteSnapshot): Observable<void> | void {
    const todayDate = new Date().toISOString();
    const dateMinus30Days = new Date(new Date().setDate(new Date().getDate() - 30)).toISOString();
    this.store.dispatch(
      referralReportsPageLoad({
        filters: { page: 0, startDate: dateMinus30Days, endDate: todayDate },
      }),
    );

    this.store.dispatch(
      loadJobFunctions({
        filters: {
          dateStart: dateMinus30Days,
          dateEnd: todayDate,
          startDate: dateMinus30Days,
          endDate: todayDate,
        },
        functionsPage: Subpages.REFERRAL_REPORT,
      }),
    );
    this.store.dispatch(
      loadReferralsByJobFunction({
        filters: {
          dateStart: dateMinus30Days,
          dateEnd: todayDate,
          startDate: dateMinus30Days,
          endDate: todayDate,
        },
      }),
    );
    this.store.dispatch(
      loadReferralsByJobDepartment({
        filters: {
          dateStart: dateMinus30Days,
          dateEnd: todayDate,
          startDate: dateMinus30Days,
          endDate: todayDate,
        },
      }),
    );
    this.store.dispatch(
      loadReferralCountByStage({
        filters: {
          startDate: dateMinus30Days,
          endDate: todayDate,
        },
      }),
    );
    this.store.dispatch(loadOldestReferralDate());
  }
}
